import React, { useState } from "react";
import cn from "classnames";
import styles from "./Faq.module.sass";
import Item from "./Item";
import Dropdown from "../../../components/Dropdown";

const items = [
  {
    title: "Gestion des dossiers OPCO",
    items: [
      {
        title: "Comment Edutio facilite-t-il l'envoi des dossiers aux OPCO ?",
        content: "Edutio automatise complètement l'envoi de vos dossiers d'apprentissage (CERFA, conventions de formation) aux OPCO. Notre plateforme valide automatiquement la complétude des dossiers avant envoi et vous fournit des accusés de réception en temps réel. Plus besoin de ressaisir ou d'envoyer manuellement vos documents."
      },
      {
        title: "Puis-je suivre le statut de mes dossiers en temps réel ?",
        content: "Oui, Edutio propose un dashboard centralisé qui vous permet de suivre la progression de tous vos dossiers depuis la soumission jusqu'à l'acceptation du financement. Vous recevez des notifications automatiques à chaque changement de statut et des alertes pour les dossiers en attente ou rejetés."
      },
      {
        title: "Comment sont gérées les pièces justificatives aux échéances ?",
        content: "Notre système envoie automatiquement les pièces justificatives requises selon les échéanciers de chaque OPCO. Les attestations de présence sont générées automatiquement, les heures effectuées sont validées avant transmission, et vous gardez un suivi complet des accusés de réception pour chaque justificatif."
      },
      {
        title: "Les certificats de réalisation sont-ils générés automatiquement ?",
        content: "Oui, dès la finalisation d'un parcours de formation, Edutio génère automatiquement les certificats de réalisation basés sur vos données d'émargement. Ces certificats respectent les formats exigés par chaque OPCO et sont envoyés automatiquement avec archivage sécurisé."
      },
    ],
  },
  {
    title: "Facturation et flux financiers",
    items: [
      {
        title: "Comment fonctionne la transmission directe des factures CFA ?",
        content: "Edutio se connecte directement aux systèmes OPCO pour transmettre vos factures d'apprentissage sans ressaisie manuelle. Vous bénéficiez d'un suivi du statut de traitement en temps réel, d'une génération automatique des documents d'accompagnement et d'un tableau de bord unifié pour piloter toute votre facturation."
      },
      {
        title: "Comment puis-je suivre mes échéanciers de paiement ?",
        content: "Notre plateforme importe automatiquement les plannings de paiement depuis vos OPCO partenaires avec une synchronisation quotidienne. Vous disposez d'un dashboard de trésorerie avec prévisions d'encaissement et de notifications proactives pour les retards de paiement."
      },
      {
        title: "Puis-je gérer les frais annexes et coûts complémentaires ?",
        content: "Oui, Edutio vous permet de paramétrer de façon flexible vos frais additionnels selon vos besoins. Vous choisissez librement les périodes de facturation pour chaque prestation grâce à une interface intuitive qui s'intègre parfaitement dans vos flux de facturation existants."
      },
      {
        title: "Mes factures sont-elles conformes aux exigences OPCO ?",
        content: "Absolument. Toutes les factures générées par Edutio respectent les formats et mentions obligatoires de chaque OPCO. Notre système assure une conformité totale aux exigences réglementaires et facilite l'acceptation de vos demandes de financement."
      },
    ],
  },
  {
    title: "Interconnexion et automatisation",
    items: [
      {
        title: "Avec quels OPCO Edutio est-il compatible ?",
        content: "Edutio est compatible avec l'ensemble des OPCO grâce à notre interface avec l'API Convergence. Cette connexion sécurisée permet d'échanger avec tous les organismes paritaires collecteurs agréés selon leurs spécificités techniques et réglementaires."
      },
      {
        title: "Comment Edutio automatise-t-il mes échanges avec les OPCO ?",
        content: "Notre processus intégré en 5 étapes automatise complètement vos échanges : transmission des dossiers, suivi des statuts, synchronisation des échéanciers, génération des factures et envoi direct aux OPCO. Chaque étape est sécurisée et traçable."
      },
      {
        title: "Mes données sont-elles sécurisées lors des échanges avec les OPCO ?",
        content: "La sécurité est notre priorité absolue. Tous les échanges avec les OPCO sont chiffrés et sécurisés. Nos serveurs respectent les normes RGPD et nos certificats SSL garantissent la confidentialité de vos données financières et administratives."
      },
      {
        title: "Puis-je conserver un contrôle sur les envois automatiques ?",
        content: "Oui, bien que le processus soit automatisé, vous gardez un contrôle total. Vous pouvez paramétrer les règles d'envoi, valider les documents avant transmission, et intervenir manuellement à tout moment. L'automatisation vous fait gagner du temps tout en préservant votre autonomie."
      },
    ],
  },
];

const Team = () => {
  const options = [];
  items.map((x) => options.push(x.title));

  const [category, setCategory] = useState(options[0]);

  return (
    <div className={cn("section", styles.section)}>
      <div className={cn("container", styles.container)}>
        <div className={styles.top}>
          <div className={cn("stage-small", styles.stage)}>
            Questions fréquentes
          </div>
          <h2 className={cn("h2", styles.title)}>FAQ – Questions fréquentes</h2>
          <div className={styles.info}>
            Découvrez les réponses aux questions les plus courantes sur notre solution d'émargement numérique ou <a href="/contact">Contactez notre support</a>
          </div>
          <div className={styles.nav}>
            {items.map((x, index) => (
              <button
                className={cn(styles.btn, {
                  [styles.active]: x.title === category,
                })}
                onClick={() => setCategory(x.title)}
                key={index}
              >
                {x.title}
              </button>
            ))}
          </div>
          <Dropdown
            className={styles.dropdown}
            value={category}
            setValue={setCategory}
            options={options}
          />
        </div>
        <div className={styles.list}>
          {items
            .find((x) => x.title === category)
            .items.map((x, index) => (
              <Item item={x} key={index} />
            ))}
        </div>
      </div>
    </div>
  );
};

export default Team;
